module.exports = __webpack_public_path__ + "img/banner.cbd222ea.png";